import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  ConfirmReceptionRequest,
  InterventionBookingStatus,
  LabCentralSearchResult,
  TestKitReceptionOptionDto,
  TestKitReceptionOptionSearchDto,
  UpsertTestKitReceptionOptionDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/lab-central`;

export const getCovidTestOverview = (
    testKitCode: string,
    source: CancelTokenSource): Promise<LabCentralSearchResult> => {

  return axios
      .get(apiUri, {params: {testKitCode}, cancelToken: source.token})
      .then((response) => response.data);
};

export const getAllTestKitReceptionOptions = (
    source: CancelTokenSource): Promise<TestKitReceptionOptionDto[]> => {

  return axios
      .get(`${apiUri}/testkit-reception-options`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchTestKitReceptionOptions = (
    testKitReceptionOptionRequest: Partial<TestKitReceptionOptionSearchDto>,
    source: CancelTokenSource): Promise<TestKitReceptionOptionDto[]> => {
  return axios
      .post(`${apiUri}/testkit-reception-options/search`,
          testKitReceptionOptionRequest,
          {cancelToken: source.token})
      .then((response) => response.data);
}

export const addTestKitReceptionOption = (
    upsertTestKitReceptionOption: Partial<UpsertTestKitReceptionOptionDto>,
    source: CancelTokenSource): Promise<TestKitReceptionOptionDto> => {

  return axios
      .post(apiUri, upsertTestKitReceptionOption, {cancelToken: source.token})
      .then(response => response.data);
}

export const editTestKitReceptionOption = (
    id: number,
    upsertTestKitReceptionOption: Partial<UpsertTestKitReceptionOptionDto>,
    source: CancelTokenSource): Promise<TestKitReceptionOptionDto> => {

  return axios
      .put(`${apiUri}/testkit-reception-options/${id}`,
          upsertTestKitReceptionOption,
          {cancelToken: source.token})
      .then(response => response.data);
}

export const getTestKitReceptionOption = (
    id: number, source: CancelTokenSource): Promise<TestKitReceptionOptionDto> => {

  return axios
      .get(`${apiUri}/testkit-reception-options/${id}`, {cancelToken: source.token})
      .then(response => response.data)
}

export const confirmLabReception = (
    request: Partial<ConfirmReceptionRequest>,
    source: CancelTokenSource): Promise<InterventionBookingStatus> => {

  return axios
      .post(`${apiUri}/confirm-reception`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const setProductNoPoolAvailableTestkit = (
    testKitCode: string,
    source: CancelTokenSource): Promise<string> => {

  return axios
      .post(`${apiUri}/no-available-pool-testkit`,
          {},
          {params: {testKitCode}, cancelToken: source.token}
      )
      .then(response => response.data);
};
